import {RECORD_CORRECT_ANSWER, RESET_CORRECT_ANSWERS_COUNT, SHOW_NEXT_OUTAGE_QUESTION, SHOW_NEXT_YEAR_END_QUESTION} from "../action";
import {AnyAction} from "redux";


/**
 * display a question
 */
export function showNextOutageQuestion(question_id?: string) : AnyAction
{
    return {type: SHOW_NEXT_OUTAGE_QUESTION, payload: {question_id}};
}


/**
 * display a question
 */
export function showNextYearEndQuestion(question_id?: string) : AnyAction
{
    return {type: SHOW_NEXT_YEAR_END_QUESTION, payload: {question_id}};
}


export function recordCorrectAnswer() : AnyAction
{
    return {type: RECORD_CORRECT_ANSWER, payload: {}};
}


export function resetCorrectAnswerCount() : AnyAction
{
    return {type: RESET_CORRECT_ANSWERS_COUNT, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/questions/questions.ts